import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useWrappedEvilNoundles from './useWrappedEvilNoundles';

const useUnstakedEvilNoundles = () => {
  const { account } = useWeb3React();
  const evilNoundles = useWrappedEvilNoundles();

  const [unstakedEvilNoundles, setUnstakedEvilNoundles] = useState([]);

  useEffect(() => {
    let ignore = false;
    setUnstakedEvilNoundles([]);
    if (evilNoundles) {
      const fetchEvilNoundles = () => {
        evilNoundles.walletOfOwner(account).then((tokenIds) => {
          if (!ignore)
            setUnstakedEvilNoundles(
              tokenIds.map((tokenId) => tokenId.toNumber())
            );
        });
      };
      fetchEvilNoundles();
      const transferFrom = evilNoundles.filters.Transfer(account);
      const transferTo = evilNoundles.filters.Transfer(null, account);
      evilNoundles.on(transferFrom, fetchEvilNoundles);
      evilNoundles.on(transferTo, fetchEvilNoundles);
      return () => {
        evilNoundles.off(transferFrom, fetchEvilNoundles);
        evilNoundles.off(transferTo, fetchEvilNoundles);
        ignore = true;
      };
    }
  }, [evilNoundles, account]);

  return unstakedEvilNoundles;
};

export default useUnstakedEvilNoundles;
